import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Alert,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  CustomInput,
  Table,
} from "reactstrap";
import FIREBASE from "../config/FIREBASE";
import { DATA_DISABILITAS_GROUP } from "../utils";
import "../assets/scss/landing-page.scss";
import LogoRote from "../assets/img/logorote.png";
import { loginUser } from "../actions/AuthAction";
import swal from "sweetalert";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLayananModalOpen, setIsLayananModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeLayananTab, setActiveLayananTab] = useState("1");
  const [statsData, setStatsData] = useState(null);
  const [loginAttempts, setLoginAttempts] = useState(0);
  const [loginProses, setLoginProses] = useState(false);
  const history = useHistory();

  // State untuk form layanan
  const [formData, setFormData] = useState({
    namaPengusul: "",
    nikPengusul: "",
    alamatPengusul: "",
    teleponPengusul: "",
    layananDipilih: [],
    dokumenSyarat: {
      suratPengantar: false,
      fotokopiKTP: false,
      fotokopiKK: false,
      bukuNikah: false,
      suratKelahiran: false,
      suratKematian: false,
      suratKehilangan: false,
      suratPernyataan: false,
      formulirF101: false,
      formulirF102: false,
      formulirF201: false,
      formulirF229: false,
      formulirF121: false,
      ktpRusak: false,
      skpwni: false,
    },
    catatan: "",
    // Field tambahan berdasarkan layanan
    dataTambahan: {
      namaAnak: "",
      tempatLahirAnak: "",
      tanggalLahirAnak: "",
      namaAlmarhum: "",
      tempatKematian: "",
      tanggalKematian: "",
      alamatTujuan: "",
      alamatAsal: "",
      alasanPenggantian: "",
      namaSuami: "",
      namaIstri: "",
      tanggalNikah: "",
      namaAnggotaPisah: "",
      alasanPisah: "",
    },
  });

  useEffect(() => {
    // Fetch statistics data for landing page
    const fetchStats = async () => {
      setLoading(true);
      try {
        // Add timeout to prevent hanging
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 second timeout

        const response = await fetch(
          `${DATA_DISABILITAS_GROUP}kecamatan-jenis`,
          { signal: controller.signal }
        );

        clearTimeout(timeoutId);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        if (data.success) {
          setStatsData(data.data);
        } else {
          console.warn("API response indicates failure:", data.message);
          setStatsData([]);
        }
      } catch (error) {
        console.error("Error fetching stats:", error);
        // Set default values if API fails
        setStatsData([]);
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, []); // Remove DATA_DISABILITAS_GROUP from dependency array

  const totalDisabilitas = statsData
    ? statsData.reduce((sum, item) => sum + (item.total_disabilitas || 0), 0)
    : 0;
  const totalKecamatan = statsData ? statsData.length : 0;

  // Fallback values if data is not available
  const displayTotalDisabilitas = loading ? 0 : totalDisabilitas;
  const displayTotalKecamatan = loading ? 0 : totalKecamatan;

  // Scroll to section function
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  // Handle login dengan versi original
  const handleLogin = async (e) => {
    e.preventDefault();
    setLoginProses(true);
    setError("");

    if (email && password) {
      // Gunakan action login original
      loginUser(email, password, setLoginProses, history);
    } else {
      swal("Failed", "Maaf Email dan Password Harus Diisi", "error");
      setLoginProses(false);
    }
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    // Reset form when opening modal
    if (!isModalOpen) {
      setEmail("");
      setPassword("");
      setError("");
    }
  };

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const toggleLayananTab = (tab) => {
    if (activeLayananTab !== tab) setActiveLayananTab(tab);
  };

  const toggleLayananModal = () => {
    setIsLayananModalOpen(!isLayananModalOpen);
    // Reset form when opening modal
    if (!isLayananModalOpen) {
      setFormData({
        namaPengusul: "",
        nikPengusul: "",
        alamatPengusul: "",
        teleponPengusul: "",
        layananDipilih: [],
        dokumenSyarat: {
          suratPengantar: false,
          fotokopiKTP: false,
          fotokopiKK: false,
          bukuNikah: false,
          suratKelahiran: false,
          suratKematian: false,
          suratKehilangan: false,
          suratPernyataan: false,
          formulirF101: false,
          formulirF102: false,
          formulirF201: false,
          formulirF229: false,
          formulirF121: false,
          ktpRusak: false,
          skpwni: false,
        },
        catatan: "",
        dataTambahan: {
          namaAnak: "",
          tempatLahirAnak: "",
          tanggalLahirAnak: "",
          namaAlmarhum: "",
          tempatKematian: "",
          tanggalKematian: "",
          alamatTujuan: "",
          alamatAsal: "",
          alasanPenggantian: "",
          namaSuami: "",
          namaIstri: "",
          tanggalNikah: "",
          namaAnggotaPisah: "",
          alasanPisah: "",
        },
      });
    }
  };

  const handleLayananChange = (layanan) => {
    const updatedLayanan = formData.layananDipilih.includes(layanan)
      ? formData.layananDipilih.filter((item) => item !== layanan)
      : [...formData.layananDipilih, layanan];

    setFormData({
      ...formData,
      layananDipilih: updatedLayanan,
    });
  };

  const handleDokumenChange = (field) => {
    setFormData({
      ...formData,
      dokumenSyarat: {
        ...formData.dokumenSyarat,
        [field]: !formData.dokumenSyarat[field],
      },
    });
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (formData.layananDipilih.length === 0) {
      swal("Peringatan", "Pilih minimal satu layanan", "warning");
      return;
    }
    if (!formData.namaPengusul || !formData.nikPengusul) {
      swal("Peringatan", "Nama dan NIK pengusul harus diisi", "warning");
      return;
    }

    // Simulasi pengajuan berhasil
    swal(
      "Berhasil",
      "Pengajuan layanan telah diterima dan akan diproses",
      "success"
    );
    toggleLayananModal();
  };

  // Fungsi untuk mendapatkan syarat berdasarkan layanan yang dipilih
  const getSyaratByLayanan = (layanan) => {
    const syaratMap = {
      "KK Baru": [
        {
          id: "suratPengantar",
          label: "Surat Pengantar RT/RW",
          required: true,
        },
        {
          id: "bukuNikah",
          label: "Fotokopi Buku Nikah atau Akta Perkawinan",
          required: true,
        },
        {
          id: "fotokopiKTP",
          label: "Fotokopi KTP suami dan istri",
          required: true,
        },
        {
          id: "suratPernyataan",
          label: "Surat Pernyataan Belum Pernah Terbit KK",
          required: false,
        },
        { id: "formulirF101", label: "Formulir F-1.01", required: true },
      ],
      "Pisah KK": [
        {
          id: "suratPengantar",
          label: "Surat Pengantar RT/RW",
          required: true,
        },
        { id: "fotokopiKK", label: "Kartu Keluarga lama", required: true },
        {
          id: "fotokopiKTP",
          label: "Fotokopi KTP anggota keluarga yang ingin pisah KK",
          required: true,
        },
        {
          id: "suratPernyataan",
          label: "Surat Pernyataan Pemisahan KK",
          required: true,
        },
        { id: "formulirF102", label: "Formulir F-1.02", required: true },
      ],
      "Akta Kelahiran": [
        {
          id: "suratKelahiran",
          label: "Surat Keterangan Lahir dari RS/Bidan/Puskesmas",
          required: true,
        },
        {
          id: "fotokopiKK",
          label: "Fotokopi Kartu Keluarga (KK)",
          required: true,
        },
        { id: "fotokopiKTP", label: "Fotokopi KTP orang tua", required: true },
        {
          id: "bukuNikah",
          label: "Fotokopi Buku Nikah/Akta Perkawinan orang tua",
          required: true,
        },
        { id: "formulirF201", label: "Formulir F-2.01", required: true },
        {
          id: "suratPernyataan",
          label:
            "Surat Pernyataan dan Berita Acara Keterlambatan (jika lewat dari 60 hari)",
          required: false,
        },
      ],
      "Akta Kematian": [
        {
          id: "suratKematian",
          label: "Surat Keterangan Kematian dari dokter/puskesmas/RS",
          required: true,
        },
        {
          id: "fotokopiKK",
          label: "Fotokopi Kartu Keluarga almarhum",
          required: true,
        },
        { id: "fotokopiKTP", label: "Fotokopi KTP almarhum", required: true },
        {
          id: "fotokopiKTP",
          label: "Fotokopi KTP pelapor dan saksi",
          required: true,
        },
        { id: "formulirF229", label: "Formulir F-2.29", required: true },
        {
          id: "suratPernyataan",
          label:
            "Surat Pernyataan Kematian (jika tidak ada surat dari RS/dokter)",
          required: false,
        },
      ],
      "Mutasi Penduduk": [
        {
          id: "suratPengantar",
          label: "Surat Pengantar RT/RW/Kepala Desa/Kelurahan",
          required: true,
        },
        { id: "fotokopiKK", label: "Kartu Keluarga (KK) asli", required: true },
        { id: "fotokopiKTP", label: "KTP-el asli", required: true },
        {
          id: "formulirF101",
          label: "Formulir F-1.03 dan F-1.04",
          required: true,
        },
        {
          id: "skpwni",
          label: "Surat Keterangan Pindah dari daerah asal (SKPWNI)",
          required: false,
        },
        {
          id: "formulirF102",
          label: "Formulir F-1.03 dan F-1.05",
          required: false,
        },
      ],
      "Penggantian KTP": [
        {
          id: "fotokopiKK",
          label: "Fotokopi Kartu Keluarga (KK)",
          required: true,
        },
        { id: "formulirF121", label: "Formulir F-1.21", required: true },
        { id: "ktpRusak", label: "KTP-el lama yang rusak", required: false },
        {
          id: "suratKehilangan",
          label: "Surat Keterangan Kehilangan dari Kepolisian",
          required: false,
        },
      ],
    };
    return syaratMap[layanan] || [];
  };

  // Fungsi untuk mendapatkan semua syarat yang diperlukan berdasarkan layanan yang dipilih
  const getAllRequiredSyarat = () => {
    const allSyarat = [];
    formData.layananDipilih.forEach((layanan) => {
      const syaratLayanan = getSyaratByLayanan(layanan);
      syaratLayanan.forEach((syarat) => {
        if (!allSyarat.find((s) => s.id === syarat.id)) {
          allSyarat.push(syarat);
        }
      });
    });
    return allSyarat;
  };

  return (
    <div className="landing-page">
      {/* Navigation */}
      <nav className="landing-nav">
        <Container>
          <Row className="align-items-center">
            <Col md="6">
              <div className="nav-brand">
                <img
                  src={LogoRote}
                  alt="Logo Rote Ndao"
                  style={{
                    width: "40px",
                    height: "40px",
                    marginRight: "10px",
                    borderRadius: "50%",
                  }}
                />
                <span>NUSAFUA-ADMINDUK</span>
              </div>
            </Col>
            <Col md="6">
              <div className="nav-menu">
                <Button
                  color="outline-light"
                  size="sm"
                  onClick={() => scrollToSection("features")}
                  className="nav-link"
                >
                  Layanan
                </Button>
                <Button
                  color="outline-light"
                  size="sm"
                  onClick={() => scrollToSection("layanan")}
                  className="nav-link"
                >
                  Adminduk
                </Button>
                <Button
                  color="outline-light"
                  size="sm"
                  onClick={() => scrollToSection("info")}
                  className="nav-link"
                >
                  Informasi
                </Button>
                <Button
                  color="primary"
                  size="sm"
                  onClick={toggleModal}
                  className="nav-link"
                >
                  Login
                </Button>
                <Button
                  color="success"
                  size="sm"
                  onClick={toggleLayananModal}
                  className="nav-link"
                >
                  Ajukan Layanan
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </nav>

      {/* Header */}
      <div className="landing-header">
        <Container>
          <Row className="align-items-center">
            <Col md="6">
              <div className="hero-content">
                <div className="hero-logo mb-4">
                  <img
                    src={LogoRote}
                    alt="Logo Rote Ndao"
                    style={{
                      width: "80px",
                      height: "80px",
                      borderRadius: "50%",
                      boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
                    }}
                  />
                </div>
                <h1 className="hero-title">NUSAFUA-ADMINDUK</h1>
                <h2 className="hero-subtitle">
                  Sistem Pendataan Penduduk Rentan
                </h2>
                <p className="hero-description">
                  Platform terpadu untuk pendataan dan layanan administrasi
                  kependudukan bagi penduduk rentan di Kabupaten Rote Ndao
                </p>
                <div className="hero-buttons">
                  <Button
                    color="primary"
                    size="lg"
                    onClick={toggleModal}
                    className="btn-hero mr-3"
                  >
                    <i className="tim-icons icon-single-02 mr-2"></i>
                    Login Admin
                  </Button>
                  <Button
                    color="success"
                    size="lg"
                    onClick={toggleLayananModal}
                    className="btn-hero mr-3"
                  >
                    <i className="tim-icons icon-paper mr-2"></i>
                    Ajukan Layanan
                  </Button>
                  <Button
                    color="outline-light"
                    size="lg"
                    onClick={() => scrollToSection("features")}
                    className="btn-hero"
                  >
                    <i className="tim-icons icon-settings mr-2"></i>
                    Pelajari Lebih Lanjut
                  </Button>
                </div>
              </div>
            </Col>
            <Col md="6">
              <div className="hero-image">
                <div className="stats-cards">
                  <Row>
                    <Col sm="6">
                      <Card className="stat-card">
                        <CardBody className="text-center">
                          <i
                            className="tim-icons icon-chart-bar-32 text-primary mb-2"
                            style={{ fontSize: "2rem" }}
                          ></i>
                          <h3 className="stat-number">
                            {loading ? (
                              <i className="tim-icons icon-refresh-02 fa-spin"></i>
                            ) : (
                              displayTotalDisabilitas
                            )}
                          </h3>
                          <p className="stat-label">Total Disabilitas</p>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col sm="6">
                      <Card className="stat-card">
                        <CardBody className="text-center">
                          <i
                            className="tim-icons icon-map-big text-info mb-2"
                            style={{ fontSize: "2rem" }}
                          ></i>
                          <h3 className="stat-number">
                            {loading ? (
                              <i className="tim-icons icon-refresh-02 fa-spin"></i>
                            ) : (
                              displayTotalKecamatan
                            )}
                          </h3>
                          <p className="stat-label">Kecamatan</p>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Features Section */}
      <div className="features-section" id="features">
        <Container>
          <Row>
            <Col md="12">
              <h2 className="section-title text-center mb-5">
                <i className="tim-icons icon-settings text-primary mr-2"></i>
                Layanan yang Tersedia
              </h2>
            </Col>
          </Row>
          <Row>
            <Col md="4">
              <Card className="feature-card">
                <CardBody className="text-center">
                  <i
                    className="tim-icons icon-single-02 text-primary mb-3"
                    style={{ fontSize: "3rem" }}
                  ></i>
                  <h4>Data Individu</h4>
                  <p>
                    Pendataan lengkap identitas diri meliputi NIK, nama lengkap,
                    tempat tanggal lahir, jenis kelamin, pendidikan, agama,
                    status perkawinan, pekerjaan, dan alamat domisili.
                  </p>
                  <div className="feature-badge">
                    <span className="badge badge-primary">Wajib Diisi</span>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col md="4">
              <Card className="feature-card">
                <CardBody className="text-center">
                  <i
                    className="tim-icons icon-chart-pie-36 text-info mb-3"
                    style={{ fontSize: "3rem" }}
                  ></i>
                  <h4>Kategori Penduduk Rentan</h4>
                  <p>
                    Pendataan khusus untuk penduduk rentan termasuk korban
                    bencana, orang terlantar, lansia, komunitas terpencil, dan
                    berbagai jenis disabilitas.
                  </p>
                  <div className="feature-badge">
                    <span className="badge badge-info">Khusus</span>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col md="4">
              <Card className="feature-card">
                <CardBody className="text-center">
                  <i
                    className="tim-icons icon-paper text-success mb-3"
                    style={{ fontSize: "3rem" }}
                  ></i>
                  <h4>Layanan Adminduk</h4>
                  <p>
                    Permohonan layanan administrasi kependudukan seperti KK
                    baru, akta kelahiran, akta kematian, mutasi penduduk, dan
                    penggantian KTP-el.
                  </p>
                  <div className="feature-badge">
                    <span className="badge badge-success">Layanan</span>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Layanan Adminduk Section */}
      <div className="layanan-section" id="layanan">
        <Container>
          <Row>
            <Col md="12">
              <h2 className="section-title text-center mb-5">
                <i className="tim-icons icon-paper text-success mr-2"></i>
                Layanan Administrasi Kependudukan
              </h2>
              <p className="text-center mb-5">
                Pilih layanan yang ingin diajukan dan pastikan semua syarat
                dokumen telah dipersiapkan
              </p>
            </Col>
          </Row>
          <Row>
            <Col md="4" className="mb-4">
              <Card className="layanan-card h-100">
                <CardBody className="text-center">
                  <i
                    className="tim-icons icon-single-02 text-primary mb-3"
                    style={{ fontSize: "3rem" }}
                  ></i>
                  <h4>1. Penerbitan Kartu Keluarga Baru</h4>
                  <p className="text-muted">
                    KK Baru karena baru menikah atau keluarga baru
                  </p>
                  <div className="syarat-list">
                    <h6>Syarat Berkas:</h6>
                    <ul className="text-left">
                      <li>Surat Pengantar RT/RW</li>
                      <li>Fotokopi Buku Nikah atau Akta Perkawinan</li>
                      <li>Fotokopi KTP suami dan istri</li>
                      <li>Surat Pernyataan Belum Pernah Terbit KK</li>
                      <li>Formulir F-1.01</li>
                    </ul>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col md="4" className="mb-4">
              <Card className="layanan-card h-100">
                <CardBody className="text-center">
                  <i
                    className="tim-icons icon-single-02 text-info mb-3"
                    style={{ fontSize: "3rem" }}
                  ></i>
                  <h4>2. Pisah Kartu Keluarga</h4>
                  <p className="text-muted">Pisah KK untuk anggota keluarga</p>
                  <div className="syarat-list">
                    <h6>Syarat Berkas:</h6>
                    <ul className="text-left">
                      <li>Surat Pengantar RT/RW</li>
                      <li>Kartu Keluarga lama</li>
                      <li>Fotokopi KTP anggota keluarga</li>
                      <li>Surat Pernyataan Pemisahan KK</li>
                      <li>Formulir F-1.02</li>
                    </ul>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col md="4" className="mb-4">
              <Card className="layanan-card h-100">
                <CardBody className="text-center">
                  <i
                    className="tim-icons icon-single-02 text-success mb-3"
                    style={{ fontSize: "3rem" }}
                  ></i>
                  <h4>3. Penerbitan Akta Kelahiran</h4>
                  <p className="text-muted">Akta kelahiran untuk anak</p>
                  <div className="syarat-list">
                    <h6>Syarat Berkas:</h6>
                    <ul className="text-left">
                      <li>Surat Keterangan Lahir dari RS/Bidan/Puskesmas</li>
                      <li>Fotokopi Kartu Keluarga (KK)</li>
                      <li>Fotokopi KTP orang tua</li>
                      <li>Fotokopi Buku Nikah/Akta Perkawinan</li>
                      <li>Formulir F-2.01</li>
                      <li>
                        Surat Pernyataan Keterlambatan (jika lebih dari 60 hari)
                      </li>
                    </ul>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col md="4" className="mb-4">
              <Card className="layanan-card h-100">
                <CardBody className="text-center">
                  <i
                    className="tim-icons icon-single-02 text-warning mb-3"
                    style={{ fontSize: "3rem" }}
                  ></i>
                  <h4>4. Penerbitan Akta Kematian</h4>
                  <p className="text-muted">Akta kematian untuk almarhum</p>
                  <div className="syarat-list">
                    <h6>Syarat Berkas:</h6>
                    <ul className="text-left">
                      <li>
                        Surat Keterangan Kematian dari dokter/puskesmas/RS
                      </li>
                      <li>Fotokopi Kartu Keluarga almarhum</li>
                      <li>Fotokopi KTP almarhum</li>
                      <li>Fotokopi KTP pelapor dan saksi</li>
                      <li>Formulir F-2.29</li>
                      <li>
                        Surat Pernyataan Kematian (jika tidak ada surat RS)
                      </li>
                    </ul>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col md="4" className="mb-4">
              <Card className="layanan-card h-100">
                <CardBody className="text-center">
                  <i
                    className="tim-icons icon-single-02 text-danger mb-3"
                    style={{ fontSize: "3rem" }}
                  ></i>
                  <h4>5. Mutasi Penduduk</h4>
                  <p className="text-muted">Pindah/Datang atau SKPWNI</p>
                  <div className="syarat-list">
                    <h6>Syarat Berkas:</h6>
                    <ul className="text-left">
                      <li>
                        <strong>Pindah Keluar:</strong>
                      </li>
                      <li>• Kartu Keluarga (KK) asli</li>
                      <li>• KTP-el asli</li>
                      <li>• Surat Pengantar RT/RW/Desa</li>
                      <li>• Formulir F-1.03 dan F-1.04</li>
                      <li>
                        <strong>Datang dari Luar:</strong>
                      </li>
                      <li>• Surat Keterangan Pindah (SKPWNI)</li>
                      <li>• KK dan KTP dari daerah asal</li>
                      <li>• Surat Pengantar RT/RW/Desa</li>
                      <li>• Formulir F-1.03 dan F-1.05</li>
                    </ul>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col md="4" className="mb-4">
              <Card className="layanan-card h-100">
                <CardBody className="text-center">
                  <i
                    className="tim-icons icon-single-02 text-secondary mb-3"
                    style={{ fontSize: "3rem" }}
                  ></i>
                  <h4>6. Penggantian KTP-el</h4>
                  <p className="text-muted">Karena Rusak / Hilang</p>
                  <div className="syarat-list">
                    <h6>Syarat Berkas:</h6>
                    <ul className="text-left">
                      <li>
                        <strong>Rusak:</strong>
                      </li>
                      <li>• KTP-el lama yang rusak</li>
                      <li>• Fotokopi Kartu Keluarga (KK)</li>
                      <li>• Formulir F-1.21</li>
                      <li>
                        <strong>Hilang:</strong>
                      </li>
                      <li>• Surat Keterangan Kehilangan dari Kepolisian</li>
                      <li>• Fotokopi Kartu Keluarga (KK)</li>
                      <li>• Formulir F-1.21</li>
                    </ul>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col md="12" className="text-center mt-4">
              <Button
                color="success"
                size="lg"
                onClick={toggleLayananModal}
                className="btn-hero"
              >
                <i className="tim-icons icon-paper mr-2"></i>
                Ajukan Layanan Sekarang
              </Button>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Stats Section */}
      <div className="stats-section">
        <Container>
          <Row>
            <Col md="12">
              <h2 className="section-title text-center mb-5 text-white">
                <i className="tim-icons icon-chart-bar-32 mr-2"></i>
                Statistik Penduduk Rentan
              </h2>
            </Col>
          </Row>
          <Row>
            <Col md="3">
              <div className="stat-item">
                <i className="tim-icons icon-single-02 text-primary"></i>
                <h3>
                  {loading ? (
                    <i className="tim-icons icon-refresh-02 fa-spin"></i>
                  ) : (
                    displayTotalDisabilitas
                  )}
                </h3>
                <p>Total Disabilitas</p>
              </div>
            </Col>
            <Col md="3">
              <div className="stat-item">
                <i className="tim-icons icon-map-big text-info"></i>
                <h3>
                  {loading ? (
                    <i className="tim-icons icon-refresh-02 fa-spin"></i>
                  ) : (
                    displayTotalKecamatan
                  )}
                </h3>
                <p>Kecamatan</p>
              </div>
            </Col>
            <Col md="3">
              <div className="stat-item">
                <i className="tim-icons icon-bank text-success"></i>
                <h3>1</h3>
                <p>Kabupaten</p>
              </div>
            </Col>
            <Col md="3">
              <div className="stat-item">
                <i className="tim-icons icon-paper text-warning"></i>
                <h3>6</h3>
                <p>Jenis Layanan</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Information Section */}
      <div className="info-section" id="info">
        <Container>
          <Row>
            <Col md="12">
              <h2 className="section-title text-center mb-5">
                <i className="tim-icons icon-bulb-63 text-warning mr-2"></i>
                Informasi Layanan
              </h2>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <Nav tabs>
                    <NavItem>
                      <NavLink
                        className={activeTab === "1" ? "active" : ""}
                        onClick={() => toggleTab("1")}
                      >
                        <i className="tim-icons icon-single-02 mr-2"></i>
                        Data Individu
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={activeTab === "2" ? "active" : ""}
                        onClick={() => toggleTab("2")}
                      >
                        <i className="tim-icons icon-chart-pie-36 mr-2"></i>
                        Penduduk Rentan
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={activeTab === "3" ? "active" : ""}
                        onClick={() => toggleTab("3")}
                      >
                        <i className="tim-icons icon-paper mr-2"></i>
                        Layanan Adminduk
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={activeTab === "4" ? "active" : ""}
                        onClick={() => toggleTab("4")}
                      >
                        <i className="tim-icons icon-settings mr-2"></i>
                        Syarat & Fitur
                      </NavLink>
                    </NavItem>
                  </Nav>
                </CardHeader>
                <CardBody>
                  <TabContent activeTab={activeTab}>
                    <TabPane tabId="1">
                      <h5>Data Individu (Identitas Diri)</h5>
                      <p>
                        Formulir wajib diisi dengan kolom-kolom sebagai berikut:
                      </p>
                      <ul>
                        <li>
                          <strong>NIK</strong> (Nomor Induk Kependudukan)
                        </li>
                        <li>
                          <strong>Nama Lengkap</strong>
                        </li>
                        <li>
                          <strong>Tempat Tanggal Lahir</strong>
                        </li>
                        <li>
                          <strong>Jenis Kelamin</strong>
                        </li>
                        <li>
                          <strong>Pendidikan Terakhir</strong>
                        </li>
                        <li>
                          <strong>Agama</strong>
                        </li>
                        <li>
                          <strong>Status Perkawinan</strong> (Belum Kawin /
                          Kawin / Cerai Hidup / Cerai Mati)
                        </li>
                        <li>
                          <strong>Pekerjaan</strong>
                        </li>
                        <li>
                          <strong>Alamat Domisili</strong> (RT/RW,
                          Desa/Kelurahan, Kecamatan, Kabupaten, Provinsi)
                        </li>
                      </ul>
                    </TabPane>
                    <TabPane tabId="2">
                      <h5>Kategori Penduduk Rentan</h5>
                      <Row>
                        <Col md="6">
                          <h6>A. Pendataan Penduduk Rentan:</h6>
                          <ul>
                            <li>☐ Penduduk Korban Bencana Alam</li>
                            <li>☐ Penduduk Korban Bencana Sosial</li>
                            <li>☐ Orang Terlantar</li>
                            <li>☐ Lansia</li>
                            <li>☐ Komunitas Terpencil</li>
                          </ul>
                        </Col>
                        <Col md="6">
                          <h6>B. Kelompok Khusus - Disabilitas:</h6>
                          <ul>
                            <li>☐ Disabilitas Fisik</li>
                            <li>☐ Disabilitas Netra/Buta</li>
                            <li>☐ Disabilitas Tunarungu/Wicara</li>
                            <li>☐ Disabilitas Mental/Jiwa</li>
                            <li>☐ Disabilitas Ganda (Fisik dan Mental)</li>
                            <li>☐ Disabilitas Lainnya</li>
                          </ul>
                        </Col>
                      </Row>
                    </TabPane>
                    <TabPane tabId="3">
                      <h5>Layanan Adminduk yang Diajukan</h5>
                      <p>
                        Pemohon dapat memilih satu atau beberapa layanan
                        berikut:
                      </p>
                      <Row>
                        <Col md="6">
                          <ul>
                            <li>☐ Penerbitan KK Baru</li>
                            <li>☐ Pisah KK</li>
                            <li>☐ Akta Kelahiran</li>
                          </ul>
                        </Col>
                        <Col md="6">
                          <ul>
                            <li>☐ Akta Kematian</li>
                            <li>☐ Mutasi Penduduk (Pindah/Datang)</li>
                            <li>☐ Penggantian Cetak KTP-el (Rusak/Hilang)</li>
                          </ul>
                        </Col>
                      </Row>
                    </TabPane>
                    <TabPane tabId="4">
                      <h5>Syarat Pendaftaran & Fitur Pendukung</h5>
                      <Row>
                        <Col md="6">
                          <h6>Syarat Pendaftaran:</h6>
                          <ul>
                            <li>Fotokopi atau Foto Dokumen Pendukung</li>
                            <li>Surat Keterangan dari Desa/Kelurahan</li>
                            <li>Dokumen pendukung kerentanan</li>
                          </ul>
                        </Col>
                        <Col md="6">
                          <h6>Fitur Pendukung:</h6>
                          <ul>
                            <li>📷 Unggah Dokumen dan Foto</li>
                            <li>📍 Geotagging Lokasi Domisili</li>
                            <li>💬 Catatan/Keterangan Tambahan</li>
                            <li>⏳ Status Permohonan</li>
                            <li>📆 Riwayat Layanan Adminduk</li>
                          </ul>
                        </Col>
                      </Row>
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Footer */}
      <div className="landing-footer">
        <Container>
          <Row>
            <Col md="12" className="text-center">
              <div className="footer-logo mb-3">
                <img
                  src={LogoRote}
                  alt="Logo Rote Ndao"
                  style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "50%",
                    filter: "brightness(0) invert(1)",
                  }}
                />
              </div>
              <p className="mb-0">
                Dinas Kependudukan dan Catatan Sipil Kabupaten Rote Ndao
              </p>
              <p className="text-muted">
                Melayani dengan sepenuh hati untuk kesejahteraan masyarakat
              </p>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Login Modal */}
      <Modal isOpen={isModalOpen} toggle={toggleModal} size="md">
        <ModalHeader toggle={toggleModal}>
          <div className="d-flex align-items-center">
            <img
              src={LogoRote}
              alt="Logo Rote Ndao"
              style={{
                width: "30px",
                height: "30px",
                marginRight: "10px",
                borderRadius: "50%",
              }}
            />
            <span>Login Admin NUSAFUA-ADMINDUK</span>
          </div>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={handleLogin}>
            <FormGroup>
              <Label for="email">Email Address</Label>
              <Input
                type="text"
                name="text"
                value={email}
                placeholder="Enter Email"
                onChange={(event) => setEmail(event.target.value)}
              />
            </FormGroup>
            <FormGroup>
              <Label for="password">Password</Label>
              <Input
                type="password"
                name="password"
                value={password}
                placeholder="Enter Password"
                onChange={(event) => setPassword(event.target.value)}
              />
            </FormGroup>
            {error && <Alert color="danger">{error}</Alert>}
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleModal}>
            Batal
          </Button>
          {loginProses ? (
            <Button color="primary" disabled>
              <i className="tim-icons icon-refresh-02 fa-spin mr-2"></i>
              Loading
            </Button>
          ) : (
            <Button color="primary" onClick={handleLogin}>
              <i className="tim-icons icon-single-02 mr-2"></i>
              Login
            </Button>
          )}
        </ModalFooter>
      </Modal>

      {/* Layanan Modal */}
      <Modal isOpen={isLayananModalOpen} toggle={toggleLayananModal} size="xl">
        <ModalHeader toggle={toggleLayananModal}>
          <div className="d-flex align-items-center">
            <img
              src={LogoRote}
              alt="Logo Rote Ndao"
              style={{
                width: "30px",
                height: "30px",
                marginRight: "10px",
                borderRadius: "50%",
              }}
            />
            <span>Form Pengajuan Layanan Adminduk</span>
          </div>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={handleFormSubmit}>
            {/* Data Pengusul */}
            <Card className="mb-4">
              <CardHeader>
                <h5 className="mb-0">
                  <i className="tim-icons icon-single-02 text-primary mr-2"></i>
                  Data Pengusul
                </h5>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col md="6">
                    <FormGroup>
                      <Label for="namaPengusul">Nama Lengkap Pengusul *</Label>
                      <Input
                        type="text"
                        name="namaPengusul"
                        value={formData.namaPengusul}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            namaPengusul: e.target.value,
                          })
                        }
                        placeholder="Masukkan nama lengkap"
                        required
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <Label for="nikPengusul">NIK Pengusul *</Label>
                      <Input
                        type="text"
                        name="nikPengusul"
                        value={formData.nikPengusul}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            nikPengusul: e.target.value,
                          })
                        }
                        placeholder="Masukkan NIK 16 digit"
                        maxLength="16"
                        required
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md="8">
                    <FormGroup>
                      <Label for="alamatPengusul">Alamat Pengusul</Label>
                      <Input
                        type="textarea"
                        name="alamatPengusul"
                        value={formData.alamatPengusul}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            alamatPengusul: e.target.value,
                          })
                        }
                        placeholder="Masukkan alamat lengkap"
                      />
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label for="teleponPengusul">Nomor Telepon</Label>
                      <Input
                        type="text"
                        name="teleponPengusul"
                        value={formData.teleponPengusul}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            teleponPengusul: e.target.value,
                          })
                        }
                        placeholder="Masukkan nomor telepon"
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </CardBody>
            </Card>

            {/* Pilihan Layanan */}
            <Card className="mb-4">
              <CardHeader>
                <h5 className="mb-0">
                  <i className="tim-icons icon-settings text-info mr-2"></i>
                  Pilih Layanan yang Diajukan *
                </h5>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col md="6">
                    <FormGroup check>
                      <CustomInput
                        type="checkbox"
                        id="layanan1"
                        label="1. Penerbitan Kartu Keluarga Baru"
                        checked={formData.layananDipilih.includes("KK Baru")}
                        onChange={() => handleLayananChange("KK Baru")}
                      />
                    </FormGroup>
                    <FormGroup check>
                      <CustomInput
                        type="checkbox"
                        id="layanan2"
                        label="2. Pisah Kartu Keluarga"
                        checked={formData.layananDipilih.includes("Pisah KK")}
                        onChange={() => handleLayananChange("Pisah KK")}
                      />
                    </FormGroup>
                    <FormGroup check>
                      <CustomInput
                        type="checkbox"
                        id="layanan3"
                        label="3. Penerbitan Akta Kelahiran"
                        checked={formData.layananDipilih.includes(
                          "Akta Kelahiran"
                        )}
                        onChange={() => handleLayananChange("Akta Kelahiran")}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup check>
                      <CustomInput
                        type="checkbox"
                        id="layanan4"
                        label="4. Penerbitan Akta Kematian"
                        checked={formData.layananDipilih.includes(
                          "Akta Kematian"
                        )}
                        onChange={() => handleLayananChange("Akta Kematian")}
                      />
                    </FormGroup>
                    <FormGroup check>
                      <CustomInput
                        type="checkbox"
                        id="layanan5"
                        label="5. Mutasi Penduduk (Pindah/Datang)"
                        checked={formData.layananDipilih.includes(
                          "Mutasi Penduduk"
                        )}
                        onChange={() => handleLayananChange("Mutasi Penduduk")}
                      />
                    </FormGroup>
                    <FormGroup check>
                      <CustomInput
                        type="checkbox"
                        id="layanan6"
                        label="6. Penggantian KTP-el (Rusak/Hilang)"
                        checked={formData.layananDipilih.includes(
                          "Penggantian KTP"
                        )}
                        onChange={() => handleLayananChange("Penggantian KTP")}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </CardBody>
            </Card>

            {/* Checklist Dokumen */}
            <Card className="mb-4">
              <CardHeader>
                <Nav tabs>
                  <NavItem>
                    <NavLink
                      className={activeLayananTab === "1" ? "active" : ""}
                      onClick={() => toggleLayananTab("1")}
                    >
                      <i className="tim-icons icon-paper mr-2"></i>
                      Checklist Dokumen
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={activeLayananTab === "2" ? "active" : ""}
                      onClick={() => toggleLayananTab("2")}
                    >
                      <i className="tim-icons icon-single-02 mr-2"></i>
                      Data Tambahan
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={activeLayananTab === "3" ? "active" : ""}
                      onClick={() => toggleLayananTab("3")}
                    >
                      <i className="tim-icons icon-chat-circle mr-2"></i>
                      Catatan
                    </NavLink>
                  </NavItem>
                </Nav>
              </CardHeader>
              <CardBody>
                <TabContent activeTab={activeLayananTab}>
                  <TabPane tabId="1">
                    {formData.layananDipilih.length === 0 ? (
                      <div className="text-center py-4">
                        <i
                          className="tim-icons icon-bell-55 text-muted"
                          style={{ fontSize: "3rem" }}
                        ></i>
                        <h5 className="text-muted mt-3">
                          Pilih Layanan Terlebih Dahulu
                        </h5>
                        <p className="text-muted">
                          Silakan pilih layanan yang ingin diajukan untuk
                          melihat syarat dokumen yang diperlukan
                        </p>
                      </div>
                    ) : (
                      <div>
                        {formData.layananDipilih.map((layanan, index) => (
                          <Card key={index} className="mb-3">
                            <CardHeader className="bg-light">
                              <h6 className="mb-0 text-primary">
                                <i className="tim-icons icon-settings mr-2"></i>
                                Syarat untuk: {layanan}
                              </h6>
                            </CardHeader>
                            <CardBody>
                              <Row>
                                {getSyaratByLayanan(layanan).map(
                                  (syarat, syaratIndex) => (
                                    <Col md="6" key={syaratIndex}>
                                      <FormGroup check>
                                        <CustomInput
                                          type="checkbox"
                                          id={`${layanan}-${syarat.id}`}
                                          label={
                                            <span>
                                              {syarat.label}
                                              {syarat.required && (
                                                <span className="text-danger ml-1">
                                                  *
                                                </span>
                                              )}
                                            </span>
                                          }
                                          checked={
                                            formData.dokumenSyarat[syarat.id]
                                          }
                                          onChange={() =>
                                            handleDokumenChange(syarat.id)
                                          }
                                        />
                                      </FormGroup>
                                    </Col>
                                  )
                                )}
                              </Row>
                            </CardBody>
                          </Card>
                        ))}

                        {/* Ringkasan Semua Syarat */}
                        <Card className="mt-4">
                          <CardHeader className="bg-info text-white">
                            <h6 className="mb-0">
                              <i className="tim-icons icon-chart-pie-36 mr-2"></i>
                              Ringkasan Semua Syarat Dokumen
                            </h6>
                          </CardHeader>
                          <CardBody>
                            <Row>
                              {getAllRequiredSyarat().map((syarat, index) => (
                                <Col md="6" key={index}>
                                  <FormGroup check>
                                    <CustomInput
                                      type="checkbox"
                                      id={`summary-${syarat.id}`}
                                      label={
                                        <span>
                                          {syarat.label}
                                          {syarat.required && (
                                            <span className="text-danger ml-1">
                                              *
                                            </span>
                                          )}
                                        </span>
                                      }
                                      checked={
                                        formData.dokumenSyarat[syarat.id]
                                      }
                                      onChange={() =>
                                        handleDokumenChange(syarat.id)
                                      }
                                    />
                                  </FormGroup>
                                </Col>
                              ))}
                            </Row>
                            <div className="mt-3">
                              <small className="text-muted">
                                <i className="tim-icons icon-info text-info mr-1"></i>
                                <span className="text-danger">*</span> = Dokumen
                                wajib
                              </small>
                            </div>
                          </CardBody>
                        </Card>
                      </div>
                    )}
                  </TabPane>
                  <TabPane tabId="2">
                    {formData.layananDipilih.length === 0 ? (
                      <div className="text-center py-4">
                        <i
                          className="tim-icons icon-bell-55 text-muted"
                          style={{ fontSize: "3rem" }}
                        ></i>
                        <h5 className="text-muted mt-3">
                          Pilih Layanan Terlebih Dahulu
                        </h5>
                        <p className="text-muted">
                          Silakan pilih layanan yang ingin diajukan untuk
                          melihat data tambahan yang diperlukan
                        </p>
                      </div>
                    ) : (
                      <div>
                        {/* Data untuk Akta Kelahiran */}
                        {formData.layananDipilih.includes("Akta Kelahiran") && (
                          <Card className="mb-3">
                            <CardHeader className="bg-success text-white">
                              <h6 className="mb-0">
                                <i className="tim-icons icon-single-02 mr-2"></i>
                                Data Anak (Akta Kelahiran)
                              </h6>
                            </CardHeader>
                            <CardBody>
                              <Row>
                                <Col md="6">
                                  <FormGroup>
                                    <Label for="namaAnak">
                                      Nama Lengkap Anak *
                                    </Label>
                                    <Input
                                      type="text"
                                      name="namaAnak"
                                      value={formData.dataTambahan.namaAnak}
                                      onChange={(e) =>
                                        setFormData({
                                          ...formData,
                                          dataTambahan: {
                                            ...formData.dataTambahan,
                                            namaAnak: e.target.value,
                                          },
                                        })
                                      }
                                      placeholder="Masukkan nama lengkap anak"
                                    />
                                  </FormGroup>
                                </Col>
                                <Col md="6">
                                  <FormGroup>
                                    <Label for="tempatLahirAnak">
                                      Tempat Lahir *
                                    </Label>
                                    <Input
                                      type="text"
                                      name="tempatLahirAnak"
                                      value={
                                        formData.dataTambahan.tempatLahirAnak
                                      }
                                      onChange={(e) =>
                                        setFormData({
                                          ...formData,
                                          dataTambahan: {
                                            ...formData.dataTambahan,
                                            tempatLahirAnak: e.target.value,
                                          },
                                        })
                                      }
                                      placeholder="Masukkan tempat lahir"
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                              <Row>
                                <Col md="6">
                                  <FormGroup>
                                    <Label for="tanggalLahirAnak">
                                      Tanggal Lahir *
                                    </Label>
                                    <Input
                                      type="date"
                                      name="tanggalLahirAnak"
                                      value={
                                        formData.dataTambahan.tanggalLahirAnak
                                      }
                                      onChange={(e) =>
                                        setFormData({
                                          ...formData,
                                          dataTambahan: {
                                            ...formData.dataTambahan,
                                            tanggalLahirAnak: e.target.value,
                                          },
                                        })
                                      }
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                            </CardBody>
                          </Card>
                        )}

                        {/* Data untuk Akta Kematian */}
                        {formData.layananDipilih.includes("Akta Kematian") && (
                          <Card className="mb-3">
                            <CardHeader className="bg-warning text-white">
                              <h6 className="mb-0">
                                <i className="tim-icons icon-single-02 mr-2"></i>
                                Data Almarhum (Akta Kematian)
                              </h6>
                            </CardHeader>
                            <CardBody>
                              <Row>
                                <Col md="6">
                                  <FormGroup>
                                    <Label for="namaAlmarhum">
                                      Nama Lengkap Almarhum *
                                    </Label>
                                    <Input
                                      type="text"
                                      name="namaAlmarhum"
                                      value={formData.dataTambahan.namaAlmarhum}
                                      onChange={(e) =>
                                        setFormData({
                                          ...formData,
                                          dataTambahan: {
                                            ...formData.dataTambahan,
                                            namaAlmarhum: e.target.value,
                                          },
                                        })
                                      }
                                      placeholder="Masukkan nama lengkap almarhum"
                                    />
                                  </FormGroup>
                                </Col>
                                <Col md="6">
                                  <FormGroup>
                                    <Label for="tempatKematian">
                                      Tempat Kematian *
                                    </Label>
                                    <Input
                                      type="text"
                                      name="tempatKematian"
                                      value={
                                        formData.dataTambahan.tempatKematian
                                      }
                                      onChange={(e) =>
                                        setFormData({
                                          ...formData,
                                          dataTambahan: {
                                            ...formData.dataTambahan,
                                            tempatKematian: e.target.value,
                                          },
                                        })
                                      }
                                      placeholder="Masukkan tempat kematian"
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                              <Row>
                                <Col md="6">
                                  <FormGroup>
                                    <Label for="tanggalKematian">
                                      Tanggal Kematian *
                                    </Label>
                                    <Input
                                      type="date"
                                      name="tanggalKematian"
                                      value={
                                        formData.dataTambahan.tanggalKematian
                                      }
                                      onChange={(e) =>
                                        setFormData({
                                          ...formData,
                                          dataTambahan: {
                                            ...formData.dataTambahan,
                                            tanggalKematian: e.target.value,
                                          },
                                        })
                                      }
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                            </CardBody>
                          </Card>
                        )}

                        {/* Data untuk KK Baru */}
                        {formData.layananDipilih.includes("KK Baru") && (
                          <Card className="mb-3">
                            <CardHeader className="bg-primary text-white">
                              <h6 className="mb-0">
                                <i className="tim-icons icon-single-02 mr-2"></i>
                                Data Keluarga Baru
                              </h6>
                            </CardHeader>
                            <CardBody>
                              <Row>
                                <Col md="6">
                                  <FormGroup>
                                    <Label for="namaSuami">
                                      Nama Lengkap Suami *
                                    </Label>
                                    <Input
                                      type="text"
                                      name="namaSuami"
                                      value={formData.dataTambahan.namaSuami}
                                      onChange={(e) =>
                                        setFormData({
                                          ...formData,
                                          dataTambahan: {
                                            ...formData.dataTambahan,
                                            namaSuami: e.target.value,
                                          },
                                        })
                                      }
                                      placeholder="Masukkan nama lengkap suami"
                                    />
                                  </FormGroup>
                                </Col>
                                <Col md="6">
                                  <FormGroup>
                                    <Label for="namaIstri">
                                      Nama Lengkap Istri *
                                    </Label>
                                    <Input
                                      type="text"
                                      name="namaIstri"
                                      value={formData.dataTambahan.namaIstri}
                                      onChange={(e) =>
                                        setFormData({
                                          ...formData,
                                          dataTambahan: {
                                            ...formData.dataTambahan,
                                            namaIstri: e.target.value,
                                          },
                                        })
                                      }
                                      placeholder="Masukkan nama lengkap istri"
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                              <Row>
                                <Col md="6">
                                  <FormGroup>
                                    <Label for="tanggalNikah">
                                      Tanggal Menikah *
                                    </Label>
                                    <Input
                                      type="date"
                                      name="tanggalNikah"
                                      value={formData.dataTambahan.tanggalNikah}
                                      onChange={(e) =>
                                        setFormData({
                                          ...formData,
                                          dataTambahan: {
                                            ...formData.dataTambahan,
                                            tanggalNikah: e.target.value,
                                          },
                                        })
                                      }
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                            </CardBody>
                          </Card>
                        )}

                        {/* Data untuk Pisah KK */}
                        {formData.layananDipilih.includes("Pisah KK") && (
                          <Card className="mb-3">
                            <CardHeader className="bg-info text-white">
                              <h6 className="mb-0">
                                <i className="tim-icons icon-single-02 mr-2"></i>
                                Data Pemisahan KK
                              </h6>
                            </CardHeader>
                            <CardBody>
                              <Row>
                                <Col md="6">
                                  <FormGroup>
                                    <Label for="namaAnggotaPisah">
                                      Nama Anggota yang Pisah KK *
                                    </Label>
                                    <Input
                                      type="text"
                                      name="namaAnggotaPisah"
                                      value={
                                        formData.dataTambahan.namaAnggotaPisah
                                      }
                                      onChange={(e) =>
                                        setFormData({
                                          ...formData,
                                          dataTambahan: {
                                            ...formData.dataTambahan,
                                            namaAnggotaPisah: e.target.value,
                                          },
                                        })
                                      }
                                      placeholder="Masukkan nama anggota yang pisah KK"
                                    />
                                  </FormGroup>
                                </Col>
                                <Col md="6">
                                  <FormGroup>
                                    <Label for="alasanPisah">
                                      Alasan Pemisahan *
                                    </Label>
                                    <Input
                                      type="select"
                                      name="alasanPisah"
                                      value={formData.dataTambahan.alasanPisah}
                                      onChange={(e) =>
                                        setFormData({
                                          ...formData,
                                          dataTambahan: {
                                            ...formData.dataTambahan,
                                            alasanPisah: e.target.value,
                                          },
                                        })
                                      }
                                    >
                                      <option value="">Pilih alasan</option>
                                      <option value="Menikah">Menikah</option>
                                      <option value="Pekerjaan">
                                        Pekerjaan
                                      </option>
                                      <option value="Pendidikan">
                                        Pendidikan
                                      </option>
                                      <option value="Lainnya">Lainnya</option>
                                    </Input>
                                  </FormGroup>
                                </Col>
                              </Row>
                            </CardBody>
                          </Card>
                        )}

                        {/* Data untuk Mutasi Penduduk */}
                        {formData.layananDipilih.includes(
                          "Mutasi Penduduk"
                        ) && (
                          <Card className="mb-3">
                            <CardHeader className="bg-danger text-white">
                              <h6 className="mb-0">
                                <i className="tim-icons icon-single-02 mr-2"></i>
                                Data Mutasi Penduduk
                              </h6>
                            </CardHeader>
                            <CardBody>
                              <Row>
                                <Col md="6">
                                  <FormGroup>
                                    <Label for="alamatAsal">
                                      Alamat Asal *
                                    </Label>
                                    <Input
                                      type="textarea"
                                      name="alamatAsal"
                                      value={formData.dataTambahan.alamatAsal}
                                      onChange={(e) =>
                                        setFormData({
                                          ...formData,
                                          dataTambahan: {
                                            ...formData.dataTambahan,
                                            alamatAsal: e.target.value,
                                          },
                                        })
                                      }
                                      placeholder="Masukkan alamat asal lengkap"
                                      rows="3"
                                    />
                                  </FormGroup>
                                </Col>
                                <Col md="6">
                                  <FormGroup>
                                    <Label for="alamatTujuan">
                                      Alamat Tujuan *
                                    </Label>
                                    <Input
                                      type="textarea"
                                      name="alamatTujuan"
                                      value={formData.dataTambahan.alamatTujuan}
                                      onChange={(e) =>
                                        setFormData({
                                          ...formData,
                                          dataTambahan: {
                                            ...formData.dataTambahan,
                                            alamatTujuan: e.target.value,
                                          },
                                        })
                                      }
                                      placeholder="Masukkan alamat tujuan lengkap"
                                      rows="3"
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                            </CardBody>
                          </Card>
                        )}

                        {/* Data untuk Penggantian KTP */}
                        {formData.layananDipilih.includes(
                          "Penggantian KTP"
                        ) && (
                          <Card className="mb-3">
                            <CardHeader className="bg-secondary text-white">
                              <h6 className="mb-0">
                                <i className="tim-icons icon-single-02 mr-2"></i>
                                Data Penggantian KTP
                              </h6>
                            </CardHeader>
                            <CardBody>
                              <Row>
                                <Col md="6">
                                  <FormGroup>
                                    <Label for="alasanPenggantian">
                                      Alasan Penggantian *
                                    </Label>
                                    <Input
                                      type="select"
                                      name="alasanPenggantian"
                                      value={
                                        formData.dataTambahan.alasanPenggantian
                                      }
                                      onChange={(e) =>
                                        setFormData({
                                          ...formData,
                                          dataTambahan: {
                                            ...formData.dataTambahan,
                                            alasanPenggantian: e.target.value,
                                          },
                                        })
                                      }
                                    >
                                      <option value="">Pilih alasan</option>
                                      <option value="Rusak">Rusak</option>
                                      <option value="Hilang">Hilang</option>
                                      <option value="Kadaluarsa">
                                        Kadaluarsa
                                      </option>
                                      <option value="Perubahan Data">
                                        Perubahan Data
                                      </option>
                                    </Input>
                                  </FormGroup>
                                </Col>
                              </Row>
                            </CardBody>
                          </Card>
                        )}
                      </div>
                    )}
                  </TabPane>
                  <TabPane tabId="3">
                    <FormGroup>
                      <Label for="catatan">Catatan/Keterangan Tambahan</Label>
                      <Input
                        type="textarea"
                        name="catatan"
                        value={formData.catatan}
                        onChange={(e) =>
                          setFormData({ ...formData, catatan: e.target.value })
                        }
                        placeholder="Masukkan catatan atau keterangan tambahan jika diperlukan..."
                        rows="4"
                      />
                    </FormGroup>
                  </TabPane>
                </TabContent>
              </CardBody>
            </Card>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleLayananModal}>
            Batal
          </Button>
          <Button color="success" onClick={handleFormSubmit}>
            <i className="tim-icons icon-paper mr-2"></i>
            Ajukan Layanan
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default Login;
